<template>
  <div>
    <div
      v-if="isHorizontalPadOrMore"
      class="custom-scrollbar-red max-h-screen overflow-y-auto shadow-drop-0 first:rounded-l-xl last:rounded-r-xl"
    >
      <div
        v-for="(item, index) in list"
        :key="item.title"
        class="cursor-pointer select-none border-b border-[#F3F3F3] p-5 font-roboto text-[16px] font-medium leading-5 last:border-b-0"
        :class="{
          'bg-[#A100090F] text-specialprojectsection': activeChapter === index,
        }"
        @click="emit('on-active-chapter', index)"
      >
        <span v-if="item?.number">Глава {{ item?.number }}. </span
        >{{ item?.title }}
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  list: {
    type: Array,
    required: true,
  },
  activeChapter: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['on-active-chapter']);

const { isHorizontalPadOrMore } = useBreakpoint();
</script>
